<template>
  <v-row align="start">
    <v-col :cols="destinationAccount?.scalingProducts?.length > 0 ? 'auto' : 3">
      <LoadableComponent :height="62" :loading="!destinationAccount">
        <DetailCard :title="$t('scalingProducts')">
          <template #title.append>
            <v-row justify="end" align="center" dense class="pl-4">
              <v-col class="py-0" v-for="p in destinationAccount?.scalingProducts" :key="p.productId" cols="auto">
                <v-chip> <span> {{ p.product }} </span> </v-chip>
              </v-col>
            </v-row>
          </template>
          <div class="my-n5"></div>
        </DetailCard>
      </LoadableComponent>
    </v-col>

    <v-col :cols="destinationAccount?.fallbackProduct ? 'auto' : 3">
      <LoadableComponent :height="62" :loading="!destinationAccount">
        <DetailCard :title="$t('fallbackProduct')">
          <template #title.append>
            <v-chip class="ml-4 mt-n3 mb-n2"><span>{{ destinationAccount?.fallbackProduct }}</span></v-chip>
          </template>
          <div class="my-n5"></div>
        </DetailCard>
      </LoadableComponent>
    </v-col>

    <v-col cols="auto">
      <DetailCard :title="$t('rateSheet')">
        <template #title.append>
          <v-btn text color="secondary" @click="rateSheetDetailClicked(activity)" class="ml-4 my-n2 mr-n2" v-if="activity.baseCost?.rateSheet">
            <span class="subtitle-2 text-capitalize">
              {{ activity.baseCost?.rateSheet.name }}
            </span>
          </v-btn>

          <span v-else class="ml-4 body-2">
            {{ $t('notSpecified') }}
          </span>
        </template>
        <div class="my-n5"></div>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ActivityVolumeInformation',

  components: {
    DetailCard: () => import('@/components/core/DetailCard.vue'),
    LoadableComponent: () => import('@/components/helper/LoadableComponent.vue')
  },

  props: {
    activity: {
      type: Object,
      required: true
    },
    destinationAccount: {
      type: Object,
      required: false,
      default: null
    }
  },

  methods: {
    rateSheetDetailClicked (activity) {
      this.$emit('rate-sheet-detail-clicked', activity)
    }
  }
}
</script>
